module.exports = new __parcel__URL__("written.a01101e6.webp").toString();